import React, { Component } from "react";
import { Modal, Form, Input, Row, Spin } from "antd";
import { inject, observer } from "mobx-react";
import co from "co";

const FormItem = Form.Item;

@Form.create({
	mapPropsToFields(props) {
		return props.fields;
	}
})
@observer
class AddEditAccountForm extends Component {
	validateForm = callback => {
		this.props.form.validateFieldsAndScroll(callback);
	};

	getValues = () => {
		return {
			siteName: this.props.form.getFieldValue("siteName"),
			email: this.props.form.getFieldValue("email"),
			username: this.props.form.getFieldValue("username"),
			password: this.props.form.getFieldValue("password")
		};
	};

	render() {
		const form = this.props.form;
		return (
			<Form>
				<FormItem style={{ marginBottom: 10 }} label="Site">
					{form.getFieldDecorator("siteName", {
						rules: [
							{
								required: true,
								message: "Please enter website"
							}
						]
					})(<Input placeholder="google.com" />)}
				</FormItem>
				<FormItem style={{ marginBottom: 10 }} label="Email">
					{form.getFieldDecorator("email", {
						rules: [
							{
								required: true,
								message: "Please enter email address"
							}
						]
					})(<Input placeholder="seo@google.com" />)}
				</FormItem>
				<FormItem style={{ marginBottom: 10 }} label="Username">
					{form.getFieldDecorator("username", {
						rules: [
							{
								required: true,
								message: "Please enter username"
							}
						]
					})(<Input placeholder="google" />)}
				</FormItem>
				<FormItem style={{ marginBottom: 10 }} label="Password">
					{form.getFieldDecorator("password", {
						rules: [
							{
								required: true,
								message: "Please enter password"
							}
						]
					})(<Input placeholder="secret" />)}
				</FormItem>
			</Form>
		);
	}
}

@inject("rootStore")
@observer
class AddEditAccountDialog extends Component {
	mapPropsToFields = () => {
		const {
			rootStore: { accountsStore }
		} = this.props;

		const ui = accountsStore.ui;

		if (ui.currentAccount == null) {
			return {};
		} else {
			return {
				siteName: Form.createFormField({
					value: ui.currentAccount.siteName
				}),
				email: Form.createFormField({
					value: ui.currentAccount.email
				}),
				username: Form.createFormField({
					value: ui.currentAccount.username
				}),
				password: Form.createFormField({
					value: ui.currentAccount.password
				})
			};
		}
	};

	validateForm = () => {
		return new Promise(resolve => {
			this.internalForm.validateForm((err, vals) => {
				resolve(err);
			});
		});
	};

	addAccount = () => {
		const {
			rootStore: { accountsStore }
		} = this.props;

		co(
			function*() {
				const response = yield this.validateForm();
				if (response != null) {
					return;
				}
				accountsStore.remoteAddAccount(this.internalForm.getValues());
			}.bind(this)
		);
	};

	hideDialog = () => {
		const {
			rootStore: { accountsStore }
		} = this.props;

		accountsStore.hideAddEditAccountDialog();
	};

	render() {
		const {
			rootStore: { accountsStore, uiStore }
		} = this.props;

		const ui = accountsStore.ui;

		let title = "Add Account";

		// let edit = false;
		// if (ui.currentAccountProfile != null && ui.currentAccountProfile.id) {
		// 	title = "Rename Account Profile";
		// 	edit = true;
		// }

		const spinning = ui.addingAccount == true || ui.renamingAccount == true;

		return (
			<Modal
				visible={ui.addEditAccountDialogVisible}
				title={title}
				okText="Save"
				onCancel={this.hideDialog}
				onOk={this.addAccount}
			>
				<Spin spinning={spinning}>
					<AddEditAccountForm
						fields={this.mapPropsToFields()}
						wrappedComponentRef={internalForm => {
							this.internalForm = internalForm;
						}}
					/>
				</Spin>
			</Modal>
		);
	}
}

export default AddEditAccountDialog;
